import { Flex, FlexProps } from '@chakra-ui/react';

function ItemListContainer({ children, ...other }: FlexProps) {
  return (
    <Flex
      justifyContent="space-evenly"
      flexWrap="wrap"
      alignItems="center"
      alignContent="center"
      height="100%"
      width="100%"
      p="20px"
      gap={3}
      data-test="slide-item-container"
      {...other}
      mb="-1000px" // TODO: this is a hack to fix the height of the container, I don't know why but this fixes everything..
      // NOTE: These are three magic values chosen to fit certain big slides such as:
      // slide 5 case 0020
      // NOTE: Slide 8 of case 019 is still problematic but it is an outlier
      px={12}
      pt={16}
      pb={8}
    >
      {children}
    </Flex>
  );
}

export default ItemListContainer;
